import messagesES from './es.json';
import Language from './language';

export default {
	[Language.ES_AR]: messagesES,
};
